import React from 'react';
import Tag from 'components/forms/Tag';

export default function renderTag(props) {
  const {
    tag, key, disabled,
    onRemove, classNameRemove,
    getTagDisplayValue, ...other
  } = props;
  return (
    <Tag
      key={key}
      {...other}
      label={getTagDisplayValue(tag)}
      color="primary"
      onDelete={() => onRemove(key)}
    />
  );
}
